import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import { shallowEqual, useSelector } from 'react-redux'

import FullScreenLoading from 'components/FullScreenLoading'

import useQueryParams from 'hooks/useQueryParams'

import AuthenticatedLayout from 'layouts/AuthenticatedLayout'

import { AppStateType } from 'redux/application/types'

import { RootState } from 'redux/store'

import { replacePath } from 'utils/mapText'

import type { IFrameApplicationParams } from './types'
import useServiceMenuQuery from 'hooks/useServiceMenuQuery'

import { useOrganizationContext } from 'contexts/OrganizationProvider'

import { sortMenu } from 'utils/sortMenu'
import { onDefaultErrorMessage } from 'utils/apollo'
import useGenerateAuthCode from 'graphQL/useGenerateAuthCode'

function IFrameApplication(): JSX.Element {
  const serviceKey = useQueryParams('serviceKey')
  const params = useParams<IFrameApplicationParams>()
  const history = useHistory()
  const organization = useOrganizationContext()
  const application: AppStateType = useSelector((state: RootState) => state.appReducer, shallowEqual)
  const { loading } = useServiceMenuQuery()
  const [generateAuthCode, generateAuthCodeResp] = useGenerateAuthCode({
    variables: {
      orgKey: organization.orgKey,
    },
    onError(error) {
      onDefaultErrorMessage(error)
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  if ((!serviceKey || serviceKey === 'undefined') && application.serviceMenus.length > 0) {
    const newServiceKey = sortMenu(application?.serviceMenus)[0]?.service.serviceKey
    history.replace(`${window.location.pathname}?serviceKey=${newServiceKey}`)
  }

  useEffect(() => {
    const listenHistory = history.listen(async () => {
      await generateAuthCode()
    })

    return () => {
      listenHistory()
    }
  }, [generateAuthCode, history])

  useEffect(() => {
    generateAuthCode()
  }, [generateAuthCode])

  return (
    <AuthenticatedLayout>
      {generateAuthCodeResp.loading || loading ? (
        <FullScreenLoading />
      ) : (
        <div className="admin-content-container">
          <iframe
            title="Configuration"
            src={replacePath(
              application?.appMenus.find((appMenu) => appMenu.service?.serviceKey === serviceKey)?.pattern || '',
              {
                endpoint: application?.appMenus.find((appMenu) => appMenu.service?.serviceKey === serviceKey)?.service
                  ?.adminPanelEndpoint,
                authorization_code: generateAuthCodeResp.data?.generateAuthCode?.payload?.code,
                credentialKey: generateAuthCodeResp.data?.generateAuthCode?.payload?.credentialKey,
                path: params.slug,
              }
            )}
            style={{ width: '100%', height: 'calc(100vh - 64px)' }}
            frameBorder="0"
          />
        </div>
      )}
    </AuthenticatedLayout>
  )
}

export default IFrameApplication
